import { render } from "./ListSeller.vue?vue&type=template&id=397b7a2d&scoped=true"
import script from "./ListSeller.vue?vue&type=script&lang=js"
export * from "./ListSeller.vue?vue&type=script&lang=js"

import "./ListSeller.vue?vue&type=style&index=0&id=397b7a2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397b7a2d"]])

export default __exports__